import React from 'react';
import { Type, Database } from 'lucide-react';

const VariableMapper = ({ variable, mapping, onUpdate, sampleLead, templateBody, leadFields }) => {
  const handleSourceChange = (source) => {
    onUpdate({
      ...mapping,
      source,
      // Default to 'name' if switching to lead_field and nothing was set
      leadField: source === 'lead_field' ? (mapping.leadField || 'name') : '',
      staticValue: source === 'static' ? (mapping.staticValue || '') : ''
    });
  };

  const handleFieldChange = (e) => {
    onUpdate({ ...mapping, leadField: e.target.value });
  };

  const handleStaticValueChange = (e) => {
    onUpdate({ ...mapping, staticValue: e.target.value });
  };

  // Generate preview for this variable
  let previewValue = '';
  if (mapping.source === 'lead_field') {
    previewValue = sampleLead ? (sampleLead[mapping.leadField] || '[Empty]') : `[${mapping.leadField}]`;
  } else {
    previewValue = mapping.staticValue || '[Empty]';
  }

  // Show a snippet of the template around the variable
  let snippetPrefix = '...';
  let snippetSuffix = '...';
  
  if (variable.format && ['image', 'video', 'document'].includes(variable.format)) {
    snippetPrefix = `Provide a public URL for the ${variable.format.toUpperCase()} header link: `;
    snippetSuffix = '';
  } else if (templateBody) {
    const regex = new RegExp(`(.{0,20})\\{\\{${variable.position}\\}\\}(.{0,20})`);
    const match = templateBody.match(regex);
    if (match) {
        snippetPrefix = match[1];
        snippetSuffix = match[2];
    }
  }

  return (
    <div style={{
      background: 'white',
      border: '1px solid var(--color-border-primary)',
      borderRadius: '8px',
      padding: '16px',
      marginBottom: '16px'
    }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '16px' }}>
        <div>
          <h4 style={{ fontWeight: '600', fontSize: '16px', margin: '0 0 4px 0' }}>Variable {'{{' + variable.position + '}}'}</h4>
          <div style={{ fontSize: '13px', color: 'var(--color-text-secondary)', fontStyle: 'italic' }}>
             "{snippetPrefix}<span style={{ fontWeight: 'bold', color: 'var(--color-brand-primary)' }}>{previewValue}</span>{snippetSuffix}"
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', gap: '16px', flexDirection: 'column' }}>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button
            onClick={() => handleSourceChange('lead_field')}
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              padding: '10px',
              border: `1px solid ${mapping.source === 'lead_field' ? 'var(--color-brand-primary)' : 'var(--color-border-primary)'}`,
              background: mapping.source === 'lead_field' ? 'var(--color-background-info)' : 'white',
              color: mapping.source === 'lead_field' ? 'var(--color-brand-primary)' : 'var(--color-text-secondary)',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: '500'
            }}
          >
            <Database size={16} /> From Lead
          </button>
          <button
            onClick={() => handleSourceChange('static')}
            style={{
              flex: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              padding: '10px',
              border: `1px solid ${mapping.source === 'static' ? 'var(--color-brand-primary)' : 'var(--color-border-primary)'}`,
              background: mapping.source === 'static' ? 'var(--color-background-info)' : 'white',
              color: mapping.source === 'static' ? 'var(--color-brand-primary)' : 'var(--color-text-secondary)',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: '500'
            }}
          >
            <Type size={16} /> Manual Value
          </button>
        </div>

        <div>
          {mapping.source === 'lead_field' ? (
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>Select CRM Field</label>
              <select 
                value={mapping.leadField || ''} 
                onChange={handleFieldChange}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '6px',
                  border: '1px solid var(--color-border-primary)',
                  fontSize: '14px'
                }}
              >
                <option value="">Select Field...</option>
                {(leadFields || []).map(field => (
                  <option key={field.value} value={field.value}>{field.label}</option>
                ))}
              </select>
            </div>
          ) : (
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>Enter Static Value</label>
              <input
                type="text"
                value={mapping.staticValue || ''}
                onChange={handleStaticValueChange}
                placeholder="e.g. ₹50 Lakhs"
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '6px',
                  border: '1px solid var(--color-border-primary)',
                  fontSize: '14px'
                }}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VariableMapper;
